import React from 'react';
import { motion } from 'framer-motion';
import './Education.css';
import irjmetsCert from '../assets/IRJMETS60800016896-2_page-0001.jpg';
import ijsermCert from '../assets/ijserm_cert.jpg';
import siiLetterPDF from '../assets/sii_letter.pdf';
import resumePDF from '../assets/suraj_resume.pdf';

const Education = () => {
  const education = [
    {
      degree: 'Bachelor of Technology in Information Science and Engineering',
      institution: 'Jain University, Bengaluru, India',
      year: '2020-2024',
      milestone: 3,
      icon: '🎓',
      details: [
        '✓ Awarded with 100% SII Scholarship Programs',
        '✓ Published Research Papers in International Journals'
      ]
    },
    {
      degree: '12th Grade',
      institution: 'P.D.C.P. College Basiath, Chainpura, Bihar, India',
      year: '2017-2019',
      board: 'Bihar Secondary Education Board (BSEB)',
      milestone: 2,
      icon: '📚'
    },
    {
      degree: '10th Grade',
      institution: 'Advance Learner Himalayan English Boarding School, Jaleswor, Mohottari, Nepal',
      year: '2016',
      board: 'School Leaving Certificate (SLC)',
      milestone: 1,
      icon: '✏️'
    }
  ];

  const researchPapers = [
    {
      title: 'ONLINE VOTING SYSTEM USING BLOCKCHAIN TECHNOLOGY',
      journal: 'International Journal of Science Research in Engineering & Management (IJSERM)',
      volume: 'Volume 8, Issue 04',
      date: 'April, 2024',
      certification: ijsermCert
    },
    {
      title: 'BLOCKCHAIN SHIPMENT MANAGEMENT TRACKING SYSTEM',
      journal: 'International Journal of Modernization in Engineering and Technology and Science (IRJMETS)',
      volume: 'Volume 06',
      date: 'August, 2024',
      certification: irjmetsCert
    }
  ];

  return (
    <motion.div
      className="education"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
    >
      <div className="container">
        <h2>Achievement Roadmap</h2>
        <div className="education-timeline">
          <div className="timeline-line"></div>
          {education.map((edu, index) => (
            <motion.div
              key={index}
              className={`education-item milestone-${edu.milestone}`}
              initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: index * 0.3, duration: 0.6 }}
              whileHover={{ scale: 1.05 }}
            >
              <div className="milestone-badge">{edu.milestone}</div>
              <div className="education-content">
                <div className="milestone-icon">{edu.icon}</div>
                <h3>{edu.degree}</h3>
                <h4>{edu.institution}</h4>
                {edu.board && <p className="board-name">{edu.board}</p>}
                <p className="year">{edu.year}</p>
                {edu.details && (
                  <ul className="education-details">
                    {edu.details.map((detail, idx) => (
                      <li key={idx}>{detail}</li>
                    ))}
                  </ul>
                )}
              </div>
            </motion.div>
          ))}
        </div>

        {/* Research Papers Section */}
        <h2 style={{ marginTop: '60px' }}>Research Publications</h2>
        <div className="research-papers">
          {researchPapers.map((paper, index) => (
            <motion.div
              key={index}
              className="research-item"
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: index * 0.3, duration: 0.6 }}
              whileHover={{ scale: 1.02 }}
            >
              {paper.certification && (
                <div className="certificate-container">
                  <img 
                    src={paper.certification} 
                    alt={`${paper.title} Certificate`}
                    className="certificate-image"
                  />
                </div>
              )}
              <div className="paper-number">📄 Paper {index + 1}</div>
              <h4 className="paper-title">{paper.title}</h4>
              <p className="paper-journal"><strong>Journal:</strong> {paper.journal}</p>
              <p className="paper-volume"><strong>{paper.volume}</strong> | {paper.date}</p>
            </motion.div>
          ))}
        </div>

        {/* Achievements Section */}
        <h2 style={{ marginTop: '60px' }}>Achievements & Awards</h2>
        <div className="achievements-section">
          <motion.div
            className="achievement-card sii-achievement"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3, duration: 0.6 }}
            whileHover={{ scale: 1.05 }}
          >
            <div className="achievement-icon">🏆</div>
            <h3>100% SII Scholarship Program</h3>
            <p>Awarded with full scholarship during B.Tech degree at Jain University (2020-2024)</p>
            <a 
              href={siiLetterPDF} 
              download="SII_Scholarship_Letter.pdf"
              className="download-button"
            >
              📄 Download Certificate
            </a>
          </motion.div>

          <motion.div
            className="achievement-card resume-achievement"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5, duration: 0.6 }}
            whileHover={{ scale: 1.05 }}
          >
            <div className="achievement-icon">📋</div>
            <h3>Professional Resume</h3>
            <p>Complete professional resume showcasing skills, experience, and achievements</p>
            <a 
              href={resumePDF} 
              download="Suraj_Kumar_Sah_Resume.pdf"
              className="download-button resume-download-btn"
            >
              📥 Download Resume
            </a>
          </motion.div>
        </div>
      </div>
    </motion.div>
  );
};

export default Education;